export const AMOUNT_SEPARATOR = '$$';
